import { render, staticRenderFns } from "./v_langCode.vue?vue&type=template&id=1b8f628e&scoped=true&"
import script from "./v_langCode.vue?vue&type=script&lang=js&"
export * from "./v_langCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8f628e",
  null
  
)

export default component.exports